import { Checkbox, Col, Colors, Row, StatusTag, Text } from 'basic-ui-lib';
import { IScreen } from 'modules/dashboard/interfaces/api';
import { StatusScreenConfigs } from 'modules/dashboard/services/constants';
import styled from 'styled-components';

interface ItemScreenProps {
  screen: IScreen;
  checked?: boolean;
  onChange?: (checked: boolean) => void;
}

const ItemScreen = ({ screen, checked, onChange }: ItemScreenProps) => {
  const handleToggle = () => {
    onChange?.(!checked);
  };

  const config = StatusScreenConfigs[screen.status];

  return (
    <Container onClick={handleToggle}>
      <Row width="100%" justifyContent='space-between'>
        <StatusTag label={config.label} backgroundColor={config.backgroundColor} color={config.color} />
        <Checkbox value={checked} onChange={(value) => onChange?.(value)} />
      </Row>

      <Col width="100%" display='flex' flexDirection='column' alignItems='flex-start' gap={4} marginLeft={4}>
        <Text left content_2 medium color='primary.6'>
          {screen.playerName}
        </Text>
        <Text left body_1 medium color='neutral.text.6'>
          {screen.businessName}
        </Text>
      </Col>
    </Container>
  );
};

export default ItemScreen;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  border-radius: 4px;
  border: 1px solid ${Colors.neutral.border[1]};
  padding: 8px;
  gap: 12px;
  align-items: center;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.15);

  .ant-checkbox-inner {
    border: 1px solid ${Colors.neutral.border[3]};
  }
`;
